import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import * as productsActions from '../../products/state/product-list/list-actions';
import * as routerSelectors from '../../route/router-state.selectors';
import * as locationsActions from './locations-actions';
import * as locationSelectors from '../../locations/state/locations-selectors';
import * as detailsActions from '../../products/state/product-details/details-actions';
import { Store } from '@ngrx/store';
import { _seoContent } from "@app/marketplace/seo-content/utils";
import { Router } from '@angular/router';

@Injectable()
export class LocationsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private router: Router,
  ) { }

  updatedlocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(locationsActions.UPDATED_LOCATION),
      withLatestFrom(
        this.store.select(routerSelectors.getMergedRoute),
        this.store.select(locationSelectors.selectLocation),
        (action: any, router: any, location: any) => {
          return {
            action,
            params: router.params,
            url: router.url,
            location: { type: location.locationType, codes: location.locations },
          }
        }
      ),
      tap((data: any) => {
        if(!data.url.startsWith('/market/productos-compras-cuba-online') &&
           !data.url.startsWith('/market/revisar-completar-pedido'))
           this.router.navigate(['/market/productos-compras-cuba-online']);
      }),
      switchMap((data: any) => {
        if (data.url.startsWith('/market/productos-compras-cuba-online')) {
          if (!data.url.includes('detalles')) {
            let payload = {
              pageIndex: 0,
              pageSize: 12,
              pagingStrategy: 0,
              locationType: 0,
              locations: null,
              locationResolver: false,
              filter: {
                searchTerms: '',
                sortingArgs: 0,
                categories: null,
                priceRange: {
                  low: 1,
                  high: 1000,
                },
              },
              categoryCode: '',
              supplierCode: '',
            };
            payload.categoryCode = "";
            payload.locationType = 0;
            payload.locations = null;
            const category = data.params['id'];
            if (category) {
              const value = _seoContent.find(x => category === x.sectionId || category === x.categoryCode);
              payload.categoryCode = value ? value.categoryCode : category;
            }
            if (data.location.codes.length > 0) {
              payload.locationType = data.location.type;
              payload.locations = data.location.codes;
            }
            //dispatch action LOADING_PRODUCTS
            return of({ type: productsActions.LOADING_PRODUCTS, payload });
          }
          else {
            let payload = {
              code: data.params["code"],
              location: 0,
              locationResolver: false,
              searchTerms: "",
            };
            if (data.location.codes.length > 0 && data.location.type === 0)
              payload.location = data.location.codes[0];
            //dispatch action LOADING_PRODUCT_DETAILS
            return of({ type: detailsActions.LOADING_PRODUCT_DETAILS });
          }
        }
        return of(locationsActions.UpdatingLocation({ locationType: {}, locations: {} }));
      })
    )
  );

}
